<template>
    <div>
        <h1 class="display-heading">Enrolled Companies</h1>

        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="40">
                        <col>
                        <col width="150">
                        <col width="150">
                        <col width="150">
                        <col width="180">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" class="text-nowrap">Company Name</th>
                            <th scope="col" class="text-nowrap">Registration Number</th>
                            <th scope="col" class="text-nowrap">Contact Person</th>
                            <th scope="col" class="text-nowrap">Contact Email</th>
                            <th scope="col" class="text-nowrap">Phone No.</th>
                            <th scope="col" class="text-nowrap">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="companyList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>

                        <tr v-for="(company, index) in companyList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>

                            <td class="text-nowrap">
                                {{ company.name }}
                            </td>
                            <td class="text-nowrap">
                                {{ company.registrationNumber }}
                            </td>
                            <td class="text-nowrap">
                                {{ company.contactPerson }}
                            </td>
                            <td class="text-nowrap">
                                {{ company.emailAddress }}
                            </td>
                            <td class="text-nowrap">
                                {{ company.phoneNumber }}
                            </td>
                            <td class="text-nowrap">
                                <a href="javascript: void(0);" @click="demoViewCompany">View Company</a>
                            </td>
                        </tr>

                    </tbody>
                </table>
                <pagination v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination';
export default {
    'name': 'CompanyUserInvitationReport',
    'components': {
        pagination
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getList();
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getList();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'companyList': []
        };
    },
    'methods': {
        getList () {
            this.axios.post('Tpa/EnrolledCompanies', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.companyList = list.map((company) => ({
                    'id': company.i,
                    'name': company.n,
                    'registrationNumber': company.r,
                    'contactPerson': company.cn,
                    'emailAddress': company.e,
                    'phoneNumber': company.p
                }));
            });
        },
        demoViewCompany () {
            alert('[To Do]: View company details will be available on next update.');
        }
    }
};
</script>
